<template>
  <div class="layout">
    <div style="display: flex; flex-direction: column">
      <app-header></app-header>
      <el-container style="height: calc(100vh - 60px)">
        <el-aside :width="isCollapse === false ? '200px' : '64px'">
          <el-menu
            :default-active="$route.path"
            class="el-menu-vertical-demo"
            :collapse="isCollapse"
            unique-opened
          >
            <template v-for="(menu, index) in menuList">
              <template>
                <el-submenu :index="menu.id + ''" :key="menu.menuId">
                  <template slot="title">
                    <img class="menu-icon" :src="getImgUrl(menu.icon)" alt="" />
                    <span slot="title" style="font-size: 15px">{{
                      menu.name
                    }}</span>
                  </template>
                  <el-menu-item-group>
                    <div
                      v-for="(item, indexSub) in menu.childrenList"
                      @click="goToPage(item.url)"
                      :key="item.id"
                    >
                      <el-menu-item :index="menu.id + '-' + item.id">{{
                        item.name
                      }}</el-menu-item>
                    </div>
                  </el-menu-item-group>
                </el-submenu>
              </template>
            </template>
          </el-menu>
        </el-aside>
        <el-main>
          <div class="crumb">
            <el-button
              type="text"
              class="el-icon-back backButton"
              @click="$router.back()"
              style="margin-right: 20px"
              v-show="!backVisible"
            />

            <el-breadcrumb separator="/">
              <template v-for="(item, index) in breadcrumbList">
                <template>
                  <el-breadcrumb-item :to="item.path" :key="'item_' + index">{{
                    item.meta.title
                  }}</el-breadcrumb-item>
                </template>
              </template>
            </el-breadcrumb>
          </div>
          <router-view style="height: calc(100% - 30px)"></router-view>
        </el-main>
      </el-container>
    </div>
  </div>
</template>

<script>
import AppHeader from "@/components/AppHeader";
import { mapGetters } from "vuex";
export default {
  name: "Layout",
  components: {
    AppHeader,
  },
  computed: {
    ...mapGetters(["userInfo"]),
    cachedViews() {
      // console.log("cache");
      // console.log(this.$store.state.tagsView.cachedViews);
      return this.$store.state.tagsView.cachedViews;
    },
    key() {
      // console.log("path");
      // console.log(this.$route.fullPath);
      return this.$route.fullPath;
    },
  },
  data() {
    return {
      isCollapse: false,
      menuList: [],
      breadcrumbList: [],

      firstLevelNode: [],
      //返回按钮显示
      backVisible: false,
    };
  },
  watch: {
    $route() {
      // console.log("watch layout");

      this.backVisible = false;

      this.firstLevelNode.forEach((item) => {
        if (this.$router.currentRoute.fullPath === item.url) {
          this.backVisible = true;
        }
      });

      // console.log(this.$router.currentRoute.fullPath);
      // console.log(this.firstLevelNode);

      // console.log(this.backVisible);

      this.getCrumb();
    },
  },
  mounted() {
    // console.log("this.userInfo");
    // console.log(this.userInfo);
    // console.log("this.userInfo");
    if (this.userInfo) {
      this.menuList = this.userInfo.menuList;

      this.menuList.forEach((value, index) => {
        value.childrenList.forEach((value1, index) => {
          this.firstLevelNode.push(value1);
        });
      });
    }

    this.backVisible = this.firstLevelNode.some((obj) =>
      obj.url.includes(this.$router.currentRoute.fullPath)
    );

    // console.log(this.backVisible);

    this.getCrumb();
  },
  methods: {
    getImgUrl(path) {
      if (path) {
        try {
          return require("../assets/menu/" + path + ".png");
        } catch (e) {
          return "";
        }
      }
    },
    goToPage(url) {
      if (url.length > 0) {
        if (/^(https?:|mailto:|tel:)/.test(url)) {
          window.location.href = url;
        } else {
          const targetPath = url.startsWith("/") ? url : "/" + url;
          const currentPath = this.$router.currentRoute.fullPath;

          // 如果目标路径和当前路径相同，使用 replace 或不做任何操作
          if (currentPath === targetPath) {
            // 可选：刷新当前视图
            this.$router
              .replace({
                path: targetPath,
                query: this.$route.query,
              })
              .catch(() => {});
            return;
          }

          this.$router.push(url).catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              console.error("导航错误:", err);
            }
          });
        }
      }
    },
    getCrumb() {
      let matched = this.$route.matched.filter((item) => {
        // console.log("getcrumb", item);
        if (item.name) {
          item.path = item.path.length == 0 ? "/" : item.path;

          if (
            item.name === "libraryTarget" &&
            this.$route.query &&
            this.$route.query.workId
          ) {
            if (this.$route.query.workId === "1") {
              item.meta.title = "养护";
            } else if (this.$route.query.workId === "2") {
              item.meta.title = "检测";
            } else if (this.$route.query.workId === "3") {
              item.meta.title = "测绘";
            } else if (this.$route.query.workId === "4") {
              item.meta.title = "抢修";
            } else if (this.$route.query.workId === "5") {
              item.meta.title = "维修(开挖)";
            } else if (this.$route.query.workId === "6") {
              item.meta.title = "维修(非开挖)";
            }
          }
          return true;
        }
      });
      const first = matched[0];
      if (first && first.name !== "Home") {
        matched = [{ path: "/", meta: { title: "首页" } }].concat(matched);
      }
      this.breadcrumbList = matched;
      this.breadcrumbList.forEach((item) => {
        // console.log("getcrumb2", item);
        // console.log("getcrumb2", this.$router.query);
        if (
          item.name === "libraryTarget" &&
          this.$router.query &&
          this.$router.query.workId
        ) {
          // console.log("getcrumb3", item);
          if (this.$router.query.workId === "1") {
            item.meta.title = "养护";
          }
        }
      });

      // console.log("breadcrumblist", this.breadcrumbList);
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.layout {
  height: 100%;
}

.el-container {
  height: calc(100vh);
}

.el-aside {
  color: #333;
  transition: width 0.15s !important;
  .el-menu {
    transition: all 10ms;
    border: none;
    height: 100%;
    overflow: hidden;
    overflow-y: auto;
    // background-color: #d3dce6;

    ::v-deep .el-menu-item-group__title {
      padding: 0;
    }
    ::v-deep .el-submenu .el-menu-item {
      padding-left: 50px !important;
    }
  }
}

.el-main {
  background-color: white;
  color: #333;
  height: calc(100vh - 60px);
  padding: 0;
  overflow: hidden;
  overflow-x: auto;
  position: relative;
  border-left: 1px solid #ccc;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}

.crumb {
  height: 40px;
  padding-left: 30px;
  right: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: rgb(217, 236, 255);

  .el-breadcrumb {
    height: 20px;
    line-height: 20px;
  }
}
//设置最后一级的面包屑颜色
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner {
  color: #2386ee;
}

.menu-icon {
  width: 18px;
  height: 18px;
  font-size: 18px;
  margin: 0 5px 0 0;
  display: inline-block;
  vertical-align: middle;
}
// .icon-htyxm {
//   background: url("../assets/menu/icon-htyxm.png");
// }
</style>
